import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import LeftSidebarNew from "../../../component/common/layout/LeftSidebarNew";
import SurveyListHeader from "../../../component/common/layout/SurveyListHeader";
import Input from "../../../core/Inputs/DefaultInput";
import { toast } from 'react-toastify';

import Button from "../../../core/Button";
import AccountSettingSidebar from "../../../component/common/layout/AccountSettingSidebar";
import SurveyListSidebar from "../../../component/common/layout/SurveyListSidebar";
import { Formik } from "formik";
import { updateUserProfileSchema } from "../../../schema/User";
import CreatableSelect from "react-select/creatable";
import {
  countryList,
  regionList,
  timezoneList,
} from "../../../store/actions/locationActions";
import {
  updateProfileData,
  uploadProfileImage,
  removeProfileImage,
  userDetail,
} from "../../../store/actions/userActions";
import { userDetailHeader } from "../../../store/actions/userDataActions";
import { useDispatch, useSelector } from "react-redux";
import NestedMenuToggle from "./NestedMenuToggle";
import { useTranslation } from 'react-i18next';
import { getSettingList } from '../../../store/actions/settingsAction';


export default function Profile() {
  const dispatch = useDispatch();
  const { countryData, regionData, timeZoneData } = useSelector(
    (state) => state.locationData
  );
  const { loggedInUserDetail, isAddingUser } = useSelector(
    (state) => state.userData
  );

  const [passwordType, setPasswordType] = useState("password");
  const [profileImageUrl, setProfileImageUrl] = useState(null);
  const [uploadingImage, setUploadingImage] = useState(false);
  const fileInputRef = useRef(null);
  const [timeZones, setTimeZones] = useState([]);
  const [regions, setRegions] = useState([]);
  const [countries, setCountries] = useState([]);
  const [selectedCountryCode, setSelectedCountryCode] = useState(null);
  const [selectedCountryName, setSelectedCountryName] = useState(null);
  const { t, i18n } = useTranslation();

  const [selectedLanguages, setSelectedLanguages] = useState([
    { value: "en", label: "English" },
    { value: "pt", label: "Portuguese" },
    { value: 'sq', label: 'Albanian' }

  ]);

  const [formValue, setFormValue] = useState({
    id: "",
    email: "",
    name: "",
    country_code: null,
    region_code: null,
    timezone: null,
    default_region_code: null,
    isEnabled: true,
    default_language: "",
  });

  const getCountryList = async (regionCode) => {
    let dataToSend = {
      regionCode: regionCode,
    };
    dispatch(countryList(dataToSend));
  };

  const getTimezones = async () => {
    dispatch(timezoneList());
  };

  const getRegionList = async () => {
    dispatch(regionList());
  };

  const getUserDetail = async () => {
    dispatch(userDetail());
  };

  // const updateProfile = async (data) => {
  //   dispatch(updateProfileData(data));

  //   if (formValue.default_language) {
  //     i18n.changeLanguage(formValue.default_language);
  //     localStorage.setItem('i18nextLng', formValue.default_language); // Change language using i18next
  //   }
  //   toast.success("Save Changes Successfully!");
  // };

  const updateProfile = async (data) => {
    try {
      await dispatch(updateProfileData(data));

      // Update language in i18n and localStorage if language was changed
      if (data.default_language) {
        i18n.changeLanguage(data.default_language);
        localStorage.setItem('i18nextLng', data.default_language);
      }

      toast.success('Save Changes Successfully!');
    } catch (error) {
      toast.error('Something went wrong! Try again.');
    }
  };

  const refreshHeader = () => dispatch(userDetailHeader());

  const handleProfileImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = ["image/jpeg", "image/png", "image/gif", "image/webp"];
    if (!allowedTypes.includes(file.type)) {
      toast.error("Please select a valid image file (JPEG, PNG, GIF, or WebP).");
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      toast.error("Image size must be less than 5MB.");
      return;
    }

    setUploadingImage(true);
    const result = await dispatch(uploadProfileImage(file, refreshHeader));
    if (result?.profile_image) {
      setProfileImageUrl(result.profile_image);
      toast.success("Profile image updated!");
    } else {
      toast.error("Failed to upload profile image.");
    }
    setUploadingImage(false);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const handleRemoveProfileImage = async () => {
    setUploadingImage(true);
    const success = await dispatch(removeProfileImage(refreshHeader));
    if (success) {
      setProfileImageUrl(null);
      toast.success("Profile image removed!");
    } else {
      toast.error("Failed to remove profile image.");
    }
    setUploadingImage(false);
  };

  const getInitials = (name) => {
    if (!name) return "";
    return name
      .split(" ")
      .map((w) => w[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };

  const handleGetSettingList = () => {
    let payload = {
      tag: 'aws',
    };
    dispatch(getSettingList(payload));
  }

  useEffect(() => {
    handleGetSettingList();
  }, [])


  useEffect(() => {
    getRegionList();
    getTimezones();
    getUserDetail();
  }, []);

  useEffect(() => {
    if (loggedInUserDetail) {
      getCountryList(loggedInUserDetail.region_code);
      setSelectedCountryCode(loggedInUserDetail.country_code);
      if (loggedInUserDetail.profile_image) {
        setProfileImageUrl(loggedInUserDetail.profile_image);
      }
      setFormValue({
        id: loggedInUserDetail.id,
        email: loggedInUserDetail.email,
        name: loggedInUserDetail.name,
        country_code: loggedInUserDetail.country_code,
        region_code: loggedInUserDetail.region_code,
        timezone: loggedInUserDetail.timezone,
        default_language: loggedInUserDetail.default_language,
        isEnabled: true,
      });
    }
  }, [loggedInUserDetail]);

  // useEffect(() => {
  //   let tempTimeZones = [];
  //   Object.keys(timeZoneData).map((ele) => {
  //     tempTimeZones.push({
  //       value: timeZoneData[ele].value,
  //       label: timeZoneData[ele].text,
  //     });
  //     setTimeZones(tempTimeZones);
  //   });
  // }, [timeZoneData]);

  useEffect(() => {
    let tempTimeZones = [];
    Object.keys(timeZoneData).map((ele) => {
      tempTimeZones.push({
        value: timeZoneData[ele].utc[0],
        label: timeZoneData[ele].text,
      });
      setTimeZones(tempTimeZones);
    });
  }, [timeZoneData]);

  useEffect(() => {
    let tempRegions = [];
    Object.keys(regionData).map((ele) => {
      tempRegions.push({
        value: regionData[ele].region_code,
        label: regionData[ele].region_name,
      });
      setRegions(tempRegions);
    });
  }, [regionData]);

  useEffect(() => {
    let tempCountries = [];
    Object.keys(countryData).map((ele) => {
      if (countryData[ele].countrycode === selectedCountryCode) {
        setSelectedCountryName(countryData[ele].name);
      }
      tempCountries.push({
        value: countryData[ele].countrycode,
        label: countryData[ele].name,
      });
      setCountries(tempCountries);
    });
  }, [countryData]);

  useEffect(() => {
    if (!isAddingUser) {
      getUserDetail();
    }
  }, [isAddingUser]);

  //  //Update language when the user selects a new language
  //   useEffect(() => {

  //   }, [formValue.default_language]);



  return (
    <>
      <div className="d-flex flex-column main-outer-wrapper main-site-wrapper bg-white">
        <SurveyListHeader />
        <div id="viewport" className="d-flex bg-white">
          <SurveyListSidebar />
          <div className="flex-grow-1 d-flex">
            <AccountSettingSidebar />
            <div className="flex-grow-1 page-content-wrap">
              <div className="page-heading">
                {/* breadcrumbs here */}
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/admin/settings/profile">{t('settings.title')}</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/admin/settings/profile">{t('settings.general_breadcrumb')}</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      <strong>{t('settings.account_settings.heading')}</strong>
                    </li>
                  </ol>
                </nav>
                {/* breadcrumbs ends here */}
                <div className="d-flex align-items-center">
                  <NestedMenuToggle />
                  <div className="flex-grow-1 ps-3 ps-lg-0">
                    <h1>{t('settings.account_settings.heading')}</h1>
                  </div>
                </div>
              </div>
              <div className="profile-wrapper">
                <div className="account-info">
                  <div className="profile-image">
                    <div className="img-wrap">
                      {profileImageUrl ? (
                        <img
                          src={`${process.env.REACT_APP_NODE_API_URL?.replace('/api', '')}${profileImageUrl}`}
                          alt="Profile"
                          className="img-fluid"
                        />
                      ) : (
                        <span>{getInitials(formValue.name)}</span>
                      )}
                      <div className="profile-hover-overlay">
                        {uploadingImage ? (
                          <span className="spinner-border spinner-border-sm text-white" role="status" />
                        ) : (
                          <>
                            <label htmlFor="editProfile" className="profile-overlay-btn" title="Upload photo">
                              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 16C13.6569 16 15 14.6569 15 13C15 11.3431 13.6569 10 12 10C10.3431 10 9 11.3431 9 13C9 14.6569 10.3431 16 12 16Z" stroke="#fff" strokeWidth="1.5"/>
                                <path d="M3 16.8V9.2C3 8.08 3 7.52 3.218 7.092C3.41 6.716 3.716 6.41 4.092 6.218C4.52 6 5.08 6 6.2 6H6.606C7.267 6 7.598 6 7.896 5.912C8.16 5.835 8.405 5.706 8.616 5.53C8.854 5.332 9.027 5.058 9.374 4.512L9.6 4.16C9.72 3.973 9.78 3.88 9.848 3.8C10.142 3.451 10.552 3.219 11.002 3.146C11.104 3.13 11.213 3.124 11.4 3.118C11.577 3.112 11.77 3.108 12 3.108C12.23 3.108 12.423 3.112 12.6 3.118C12.787 3.124 12.896 3.13 12.998 3.146C13.448 3.219 13.858 3.451 14.152 3.8C14.22 3.88 14.28 3.973 14.4 4.16L14.626 4.512C14.973 5.058 15.146 5.332 15.384 5.53C15.595 5.706 15.84 5.835 16.104 5.912C16.402 6 16.733 6 17.394 6H17.8C18.92 6 19.48 6 19.908 6.218C20.284 6.41 20.59 6.716 20.782 7.092C21 7.52 21 8.08 21 9.2V16.8C21 17.92 21 18.48 20.782 18.908C20.59 19.284 20.284 19.59 19.908 19.782C19.48 20 18.92 20 17.8 20H6.2C5.08 20 4.52 20 4.092 19.782C3.716 19.59 3.41 19.284 3.218 18.908C3 18.48 3 17.92 3 16.8Z" stroke="#fff" strokeWidth="1.5"/>
                              </svg>
                            </label>
                            {profileImageUrl && (
                              <button
                                type="button"
                                className="profile-overlay-btn"
                                onClick={handleRemoveProfileImage}
                                disabled={uploadingImage}
                                title="Remove photo"
                              >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M4 7H20" stroke="#fff" strokeWidth="1.5" strokeLinecap="round"/>
                                  <path d="M10 11V17" stroke="#fff" strokeWidth="1.5" strokeLinecap="round"/>
                                  <path d="M14 11V17" stroke="#fff" strokeWidth="1.5" strokeLinecap="round"/>
                                  <path d="M5 7L6 19C6 20.1046 6.89543 21 8 21H16C17.1046 21 18 20.1046 18 19L19 7" stroke="#fff" strokeWidth="1.5" strokeLinecap="round"/>
                                  <path d="M9 7V4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V7" stroke="#fff" strokeWidth="1.5" strokeLinecap="round"/>
                                </svg>
                              </button>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                    <input
                      type="file"
                      name="profile_image"
                      id="editProfile"
                      accept="image/jpeg,image/png,image/gif,image/webp"
                      ref={fileInputRef}
                      onChange={handleProfileImageChange}
                      disabled={uploadingImage}
                      style={{ display: "none" }}
                    />
                  </div>
                  <Formik
                    initialValues={formValue}
                    enableReinitialize
                    validationSchema={updateUserProfileSchema}
                    onSubmit={(values, { setSubmitting, resetForm }) => {
                      let dataToSend = {
                        id: values.id,
                        name: values.name,
                        email: values.email,
                        country_code: values.country_code,
                        region_code: values.region_code,
                        timezone: values.timezone,
                        default_language: values.default_language,
                      };
                      // updateProfile(dataToSend);
                      updateProfile(dataToSend).finally(() => {
                        setSubmitting(false);
                      });
                    }}
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      setFieldValue,
                      isSubmitting,
                    }) => (
                      <form onSubmit={handleSubmit}>
                        <div className="form-wrapper custom-width">
                          <div className="row">
                            <div className="col-lg-6">
                              <div className="mb-3">
                                <label htmlFor="">{t('settings.account_settings.email')}</label>
                                <Input
                                  type="email"
                                  name="email"
                                  view="outlined"
                                  dense={false}
                                  color="default"
                                  label=""
                                  placeholder={t('settings.account_settings.email')}
                                  clearButton={true}
                                  success={false}
                                  error={false}
                                  fill={true}
                                  errorHelperText={null}
                                  className={"formsinput"}
                                  value={values.email}
                                  onChange={handleChange}
                                  readOnly
                                />
                              </div>
                            </div>
                            <div className="col-lg-6 position-relative">
                              <div className="mb-3">
                                <label htmlFor="">{t('settings.account_settings.user_name')}<span className="text-primary">*</span></label>
                                <Input
                                  type="text"
                                  view="outlined"
                                  dense={false}
                                  color="default"
                                  label=""
                                  placeholder={t('settings.account_settings.user_name')}
                                  clearButton={true}
                                  success={false}
                                  error={false}
                                  fill={true}
                                  errorHelperText={null}
                                  className={"formsinput"}
                                  name="name"
                                  value={values.name}
                                  onChange={handleChange}
                                />
                              </div>
                              {errors.name && (
                                <div className="validation-msg">
                                  {errors.name}
                                </div>
                              )}
                            </div>
                            {/* <div className="col-lg-6">
                              <div className="mb-3">
                                <label htmlFor="">Organization Name</label>
                                <Input
                                  type="text"
                                  view="outlined"
                                  dense={false}
                                  color="default"
                                  label=""
                                  placeholder="Organization Name"
                                  clearButton={true}
                                  success={false}
                                  error={false}
                                  fill={true}
                                  errorHelperText={null}
                                  className={"formsinput"}
                                />
                              </div>
                            </div> */}
                            <div className="col-md-6 position-relative">
                              <div className="mb-3 cstom-select">
                                <label htmlFor="">{t('settings.account_settings.region')}</label>
                                <CreatableSelect
                                  value={
                                    regions
                                      ? regions.find(
                                        (option) =>
                                          option.value === values.region_code
                                      )
                                      : ""
                                  }
                                  placeholder={t('settings.account_settings.region')}
                                  options={regions}
                                  onChange={(e) => {
                                    getCountryList(e.value);
                                    setFieldValue("region_code", e.value);
                                  }}
                                />
                              </div>
                              {errors.region_code && touched.region_code && (
                                <div className="validation-msg">
                                  {errors.region_code}
                                </div>
                              )}
                            </div>
                            <div className="col-md-6 position-relative">
                              <div className="mb-3 cstom-select">
                                <label htmlFor="">{t('settings.account_settings.country')}</label>
                                <CreatableSelect
                                  value={
                                    countries
                                      ? countries.find(
                                        (option) =>
                                          option.value === values.country_code
                                      )
                                      : ""
                                  }
                                  placeholder={t('settings.account_settings.country')}
                                  options={countries}
                                  onChange={(e) => {
                                    setFieldValue("country_code", e.value);
                                  }}
                                />
                              </div>
                              {errors.country_code && touched.country_code && (
                                <div className="validation-msg">
                                  {errors.country_code}
                                </div>
                              )}
                            </div>
                            <div className="col-md-6">
                              <div className="mb-3 cstom-select">
                                <label htmlFor="">{t('settings.account_settings.timezone')}</label>
                                <CreatableSelect
                                  value={
                                    timeZones
                                      ? timeZones.find(
                                        (option) =>
                                          option.value === values.timezone
                                      )
                                      : ""
                                  }
                                  placeholder={t('settings.account_settings.timezone')}
                                  options={timeZones}
                                  onChange={(e) => {
                                    setFieldValue("timezone", e.value);
                                  }}
                                />
                              </div>
                              {errors.timezone && touched.timezone && (
                                <div className="validation-msg">
                                  {errors.timezone}
                                </div>
                              )}
                            </div>
                            <div className="col-md-6 position-relative">
                              <div className="mb-3 cstom-select">
                                <label htmlFor="">{t('settings.account_settings.default_language')}</label>
                                <CreatableSelect
                                  value={
                                    selectedLanguages.find(option => option.value === values.default_language)
                                  }
                                  placeholder={t('settings.account_settings.default_language')}
                                  options={selectedLanguages}
                                  onChange={(e) => setFieldValue('default_language', e.value)}
                                />
                              </div>
                              {errors.region_code && touched.region_code && (
                                <div className="validation-msg">
                                  {errors.region_code}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="btn-wrap">
                            <button
                              className={"formsbutton btn-bordered btn"}
                              type="submit"
                              view="outlined"
                              color="primary"
                            >
                              {isAddingUser ? (
                                <>
                                  <span
                                    className="white-spinner spinner-border spinner-border-sm"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                  <span className="visually-hidden">
                                    Loading...
                                  </span>
                                </>
                              ) : (
                                t('settings.account_settings.save_changes')
                              )}
                            </button>
                          </div>
                        </div>
                      </form>
                    )}
                  </Formik>


                  <div className="form-wrapper custom-width role-list">
                    <div className="profile-heading border-0 p-0 mb-2">{t('settings.account_settings.assignTeamRole')}</div>
                    <table className="table">
                      <thead>
                        <tr>
                          <th scope="col">{t('settings.team.heading')}</th>
                          <th scope="col">{t('settings.roles.heading')}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loggedInUserDetail?.teams_and_roles?.map((team, index) => (
                          <tr key={index}>
                            <td>{team.team_name}</td>
                            <td>{team.role_name}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>



                </div>
                {/* <div className="account-preference">
                  <div className="form-heading">
                    <h4>Account Preferences</h4>
                  </div>

                  <div className="btn-wrap">
                    <a href="#" className="btn btn-danger-text">
                      Delete Account
                    </a>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
